import { EntityAdapter } from '../adapters/interfaces/entity.adapter';
import { SortStrategy } from './interfaces/sort-strategy';

export class LabelSortStrategy<T> implements SortStrategy<T> {
  public compare(left: T, right: T, adapter: EntityAdapter<T>): number {
    return adapter.getLabel(left).localeCompare(adapter.getLabel(right));
  }
}
